import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export const checkAndGetDealerAndLocationId = (dealer: string) => {
  if (!dealer || dealer === '') {
    return null;
  }
  const parts = dealer.split('_');
  if (parts.length !== 2) {
    return null;
  }
  const location_id = parts[0];
  const dealer_id = parts[1];

  return { dealer_id, location_id };

  return null;
};